import React from 'react'

import { func, string } from 'prop-types'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import FilterChip from '../../../Shared/FilterChip/FilterChip'

// Extracted so each chip subscribes only to the slice it cares about - sibling
// toggles don't trigger this row's re-render.
function TechnicalAttributesChip({ chipKey, select, onChange }) {
  const t = useTranslate()

  const isChecked = useSearchPageStore(select)

  return (
    <FilterChip
      id={`technical-attr-${chipKey}`}
      label={t(`search_page.filters.technical_attributes.${chipKey}`)}
      isChecked={isChecked}
      onChange={onChange}
    />
  )
}

TechnicalAttributesChip.propTypes = {
  chipKey: string.isRequired,
  select: func.isRequired,
  onChange: func.isRequired,
}

export default TechnicalAttributesChip
